import BlueHouse from './BlueHouse';
import Coins from './Coins';
import Crumpled from './Crumpled';
import Lineart from './Lineart';

export default function SkinComponent({ skin, ...restProps }) {
    switch(skin) {
        case 'bluehouse':
            return <BlueHouse {...restProps} />;
        case 'coins':
            return <Coins {...restProps} />;
        case 'lineart':
            return <Lineart {...restProps} />;
        case 'crumpled':
        default:
            return <Crumpled {...restProps} />;
    }
}
